import { css } from '@styled-system/css';

// Pastille « en direct » pulsante (onde sonar), partagée liste + détail.
export const liveDot = css({
  width: '8px',
  height: '8px',
  borderRadius: 'full',
  bg: 'success.default',
  flexShrink: 0,
  animation: 'sonar 1.8s ease-out infinite',
});

export const liveBadge = css({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '2',
  paddingY: '1',
  paddingX: '3',
  borderRadius: 'full',
  fontSize: 'caption',
  fontWeight: 'semibold',
  bg: 'success.soft',
  color: 'success.default',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'success.border',
  whiteSpace: 'nowrap',
});

export const pausedBadge = css({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '1.5',
  paddingY: '1',
  paddingX: '3',
  borderRadius: 'full',
  fontSize: 'caption',
  fontWeight: 'semibold',
  bg: 'surface.sunken',
  color: 'text.tertiary',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'border.default',
  whiteSpace: 'nowrap',
  flexShrink: 0,
});
